/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiFrontendInternalLinkingRegionLocaleRetrieve200 } from './model/apiFrontendInternalLinkingRegionLocaleRetrieve200';

export const apiFrontendInternalLinkingRegionLocaleRetrieve = (
  countryCode: string,
  language: string,
  regionSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendInternalLinkingRegionLocaleRetrieve200>({
    url: `/api/v7/frontend/internal-linking/${countryCode}/${language}/${regionSlug}/`,
    method: 'GET',
    signal,
  });
};

export const getApiFrontendInternalLinkingRegionLocaleRetrieveQueryKey = (
  countryCode?: string,
  language?: string,
  regionSlug?: string
) => {
  return [`/api/v7/frontend/internal-linking/${countryCode}/${language}/${regionSlug}/`] as const;
};

export const getApiFrontendInternalLinkingRegionLocaleRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionLocaleRetrieve>>,
  TError = ErrorType<void>
>(
  countryCode: string,
  language: string,
  regionSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionLocaleRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendInternalLinkingRegionLocaleRetrieveQueryKey(countryCode, language, regionSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionLocaleRetrieve>>
  > = ({ signal }) =>
    apiFrontendInternalLinkingRegionLocaleRetrieve(countryCode, language, regionSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(countryCode && language && regionSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionLocaleRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiFrontendInternalLinkingRegionLocaleRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionLocaleRetrieve>>
>;
export type ApiFrontendInternalLinkingRegionLocaleRetrieveQueryError = ErrorType<void>;

export function useApiFrontendInternalLinkingRegionLocaleRetrieve<
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionLocaleRetrieve>>,
  TError = ErrorType<void>
>(
  countryCode: string,
  language: string,
  regionSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionLocaleRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendInternalLinkingRegionLocaleRetrieveQueryOptions(
    countryCode,
    language,
    regionSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
